export default __webpack_public_path__ + "static/shape-1bfe13982f45fa774b84762f50dae1b0.svg";